import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

export const getEventUsersList = (eventId) => api.get(url.GET_VIEW_EVENT_USERS_LIST(eventId));

